module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_bouquet-5bfb50c3dd9fd1bbebc28791e989ee23.png";